player.playerBonusModule = {
    // Funkcia sluzi na ziskanie hrackych bonusov a otvorenie konkretnej hracskej podstranky
    playerBonuses: function(openPlayerBonus) {
        try {
            // Zatvori aktualne otvorene okno (marketingove podstranky)
            main.closeDialog();
            // Nastavi callback funkciu pre otvorenie podstranky hracskeho bonusu
            stored.callPlayerBonusCB = function() {
                var indexToOpen = 0;
                if (openPlayerBonus) {
                    indexToOpen = more.menu.assignBonusSubPageMenu(stored.playerBonuses, openPlayerBonus, "bonusName");
                }
                $("#playerBonusesModal #bonusesList").children().eq(indexToOpen).trigger('mousedown');
            }
            service.loadPure("playerBonuses");
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia sluzi ako razcestie volania hracskych bonusov pre prihlaseneho alebo neprihlaseneho hraca
    playerBonusesFromMarketingSubPage: function(page, bonusName) {
        try {
            main.closeDialog();
            if (stored.PlayerID && stored.PlayerID !== profile.ManualVerifiedPlayerID) {
                // Zobrazi loader
                $("#playerBonusesModal #bonusLoader").show();
                // Pre prihlaseneho hraca najskor ziska data a cez callback zavola konkretnu podstranku
                player.playerBonusModule.playerBonuses(bonusName);
            } else if (page) {
                // Pre neprihlaseneho hraca otvori priamo okno player bonusov, bez dodatocneho requestu (ulozene data)
                var data = $("#bonuses #clubContent #paragraph" + page + " #showMyState").data('menuData');
                var iframeData = $("#bonuses #clubContent #paragraph" + page + " #showMyState").data('iframeData');
                if (data && iframeData) {
                    setTimeout(function() {
                        player.playerBonusModule.playerBonusesMenuRender(data, iframeData);
                    }, 100);
                }
            } else {
                // Neziaduci stav kedy hrac nieje prihlaseny, ale tukol na tlacidlo bonusy v tikete
                setTimeout(function() {
                    main.createLog(2, "PlayerBonusesButtonCalled", " # PlayerID: " + stored.PlayerID);
                    main.closeDialog();
                    modal.showErrObj(2, 5, {err1: texts.Bonuses_ERR_NO_BONUSES, errType: "Bonuses_ERR_NO_BONUSES"});
                }, 0);
                return false;
            }
        } catch (e) {
            $("#playerBonusesModal #bonusLoader").hide();
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na zobrazenie bonusov
    playerBonusesMenuRender: function(data, iframeData) {
        try {
            if (data && data.length) {
                $("#playerBonusesModal").removeClass("no-menu");
                var vipBonusesData = [];
                stored.playerBonuses = data.filter(function(pb) {
                    if (pb.bonusName && pb.bonusID) {
                        if (pb.bonusType === "Vip" || pb.bonusType === "VipSuper") {
                            vipBonusesData.push(pb);
                        } else {
                            return pb;
                        }
                    }
                }).sort(function(pbA, pbB) {
                    return pbA.loggedClientRecordOrder - pbB.loggedClientRecordOrder;
                });
                if (vipBonusesData.length) {
                    // Samostatne poradie VIP bonusov - na zaciatok
                    vipBonusesData.sort(function(vipA, vipB) {
                        return vipA.loggedClientRecordOrder - vipB.loggedClientRecordOrder;
                    });
                    stored.playerBonuses.unshift(vipBonusesData);
                    stored.playerBonuses = stored.playerBonuses.reduce(function(a, b) {
                        return a.concat(b);
                    }, []);
                }
                dialog.open({
                    id: "playerBonusesModal",
                    persistent: true,
                    parseJQM: false,
                    backdropDismiss: false,
                    onClose: function() { $("#playerBonusesModal #promocodeInput").val(''); } // Vymazanie hodnoty z inputu promokodu pri zatvarani modalu lebo inak by tam ostaval aj pri opatovnom otvoreni
                });

                // Rozklinutie konkretneho bonusu
                if (iframeData) {
                    // Otvorenie detailu bonusu pre hraca bez dodatocneho requestu (zobrazeny v menu je len bonus iframe, stored.activeBonusName nieje potrebne nastavovat)
                    $("#playerBonusesModal").addClass("no-menu");
                    stored.bonusesStaticUrl = data[0].iFrameProgressUrl;
                    if (profile.Resolution === "1280x1024") {
                        stored.bonusesStaticUrl += "?zoom=" + sets.contentFactor1280x1024;
                    }
                    $("#bonusesContent").append('<iframe id="' + data[0].bonusName + 'Iframe" src="' + stored.bonusesStaticUrl + '" frameborder="0" scrolling="yes" class="bonus-iframe"></iframe>');
                    $("#" + data[0].bonusName + "Iframe").load(function() {
                        document.getElementById(data[0].bonusName + 'Iframe').contentWindow.postMessage(iframeData, '*');
                    });
                } else if (stored.callPlayerBonusCB && typeof stored.callPlayerBonusCB === 'function') {
                    $p("#playerBonusesModal #bonusesList").render(stored.playerBonuses, T.playerBonusesMenu);
                    stored.callPlayerBonusCB();
                }
                $("#playerBonusesModal #bonusLoader").hide();

                return true;
            } else {
                $("#playerBonusesModal #bonusLoader").hide();
                modal.showErrObj(2, 5, {err1: texts.Bonuses_ERR_NO_BONUSES, errType: "Bonuses_ERR_NO_BONUSES"});
                return false;
            }
        } catch (e) {
            $("#playerBonusesModal #bonusLoader").hide();
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia sluzi na ziskanie dat detailu bonusu a preposlanie dat do iframe
    getBonusDetail: function(bonusID, bonusName, isMarketingPage) {
        try {
            if (bonusName && bonusName !== "undefined") {
                var requestUrl, auth = false;
                if (stored.PlayerID && (stored.PlayerID !== profile.ManualVerifiedPlayerID) && stored.Token) {
                    requestUrl = url.centralSB + "/ac/bonus-detail?forPlatform=" + offer.platform + "&bonusName=" + bonusName + "&languageId=" + offer.bonusesLang;
                    auth = true;
                } else {
                    // TODO: kedy sa pouziva?
                    console.log("getBonusDetail without auth, bonusName: " + bonusName);
                    requestUrl = url.centralSB + "/bonus/bonus-detail?forPlatform=" + offer.platform + "&bonusName=" + bonusName + "&languageId=" + offer.bonusesLang;
                }
                $.ajax({
                    type: "GET",
                    url: requestUrl,
                    dataType: "json",
                    async: true,
                    beforeSend: function(xhr) {
                        if (auth) {
                            xhr.setRequestHeader("Authorization", "Bearer " + stored.Token);
                        }
                    }
                })
                    .done(function(data) {
                        // Kontrola objektu
                        if (data === Object(data)) {
                            try {
                                if (isMarketingPage) {
                                    $("#bonuses #paragraph" + bonusID + " #showMyState").remove();
                                    more.menu.bonusPage(bonusID, bonusName, data.isAvailableBonus, data.bonusIframeData, data.iFrameProgressUrl);
                                } else {
                                    document.getElementById(bonusName + 'Iframe').contentWindow.postMessage(data.bonusIframeData, '*');
                                }
                            } catch (e) {
                                $("#bonuses #paragraph" + bonusID + " #showMyState").remove();
                                main.createLog(2, "playerBonusDetail_Failed", "POSTMESSAGE FAILED: " + JSON.stringify(data.bonusIframeData));
                            }
                        } else {
                            // Ak server vratil not-object odpoved
                            $("#bonuses #paragraph" + bonusID + " #showMyState").remove();
                            main.createLog(2, "playerBonusDetail_Failed", "RequestURL: " + requestUrl);
                            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
                            return false;
                        }
                        return true;
                    })
                    .fail(function (jqXHR) {
                        $("#bonuses #paragraph" + bonusID + " #showMyState").remove();
                        jqXHR.requestUrl = requestUrl;
                        main.createLog(2, "playerBonusDetail_Failed", "# AJAX FAILED: " + JSON.stringify(jqXHR));
                        modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
                        return false;
                    });
            } else {
                $("#bonuses #paragraph" + bonusID + " #showMyState").remove();
                main.createLog(2, "playerBonusDetail_Failed_Err", "# PlayerID: " + stored.PlayerID + " # bonusID: " + bonusID + " # bonusName: " + bonusName + " # isMarketingPage: " + isMarketingPage);
                modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            return false;
        }
    },

    // Funkcia sluzi na ochytenie akcie playera po kliknuti na button vo vnutri detailu bonusu (iframe)
    listenBonusDetailIframe: function() {
        try {
            window.addEventListener('message', function(data) {
                // Pocuva na postMessage len zo static-u
                if (data.origin === url.static) {
                    if (data.data !== 'onload') {
                        try {
                            data = JSON.parse(data.data);
                            if (data.type === "BonusInfo") {
                                bonusIsPresent = profile.BonusList.find(function(bonus, bonusIndex) {
                                    if (data.data.BonusTitle === bonus.bonusTitle) {
                                        return bonus;
                                    }
                                });
                                if (!bonusIsPresent) {
                                    profile.BonusList.push({
                                        bonusTitle: data.data.BonusTitle,
                                        sportboxBonusImageUrl: data.data.SportboxBonusImageUrl,
                                        sportboxTermsAndConditionsImageUrl: data.data.SportboxTermsAndConditionsImageUrl,
                                        bonusName: data.data.BonusTitle,
                                        loggedClientRecordOrder: -2
                                    });
                                    profile.BonusList.sort(function(blA, blB) {
                                        return blA.loggedClientRecordOrder - blB.loggedClientRecordOrder;
                                    });
                                }
                            } else if (data.type === 'navigate' && (nav = data.data.destination)) {
                                var navSplit = nav.split('/');
                                switch (navSplit[navSplit.length - 2]) {
                                    case "ticketCode":
                                        main.closeDialog();
                                        if (navSplit[navSplit.length - 1].length === sets.lengthStoredTicketID) {
                                            setTimeout(function() {
                                                ticketDetail.ticketCodeTicketInput(navSplit[navSplit.length - 1]);
                                            }, 200);
                                        } else {
                                            console.error('ticketCodeTicketInput wrong string length ' + navSplit[navSplit.length - 1]);
                                        }
                                        return true;
                                    break;
                                }
                                // Ak existuju marketingove podstranky
                                switch (navSplit[navSplit.length - 1]) {
                                    case "sportove-tipovanie":
                                        main.closeDialog();
                                        setTimeout(function() {
                                            main.setPage(2);
                                        }, 200);
                                    break;
                                    default:
                                        player.playerBonusModule.openBonusSubPage(nav, navSplit);
                                    break;
                                }
                            }
                        } catch (e) {
                            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                            return false;
                        }
                    }
                }
            });
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia otvara bonusovu podstranku
    openBonusSubPage: function(nav, navSplit) {
        if (nav && !navSplit) {
            navSplit = nav.split('/');
        }
        if (Array.isArray(profile.BonusList) && profile.BonusList.length) {
            switch (navSplit[navSplit.length - 1]) {
                // Otvara sekciu bonusov
                case "bonusy-a-akcie":
                    main.closeDialog();
                    setTimeout(function() {
                        main.openPage("bonuses", profile.BonusOpenDefault);
                    }, 200);
                break;
                default:
                    if (navSplit[navSplit.length - 2] === "bonusy-a-akcie") {
                        if (profile.BonusList && navSplit[navSplit.length - 1]) {
                            main.closeDialog();
                            setTimeout(function() {
                                main.openPage("bonuses", more.menu.assignBonusSubPageMenu(profile.BonusList, nav, "param"));
                            }, 200);
                        }
                    } else {
                        // V pripade ak sa jedna o bonus len pre prihlaseneho hraca
                        main.openPage("bonuses", profile.BonusOpenDefault);
                    }
                break;
            }
        } else {
            more.menu.getBonusList(false, navSplit);
        }
    },

    // Funkcia sluzi na zobrazenie detailu
    playerBonusDetail: function(bonusID, bonusName, bonusType, iFrameProgressUrl, param) {
        try {
            if (bonusID && bonusName !== stored.activeBonusName) {
                // Najskor zrusi iframe a oznacenie aktualne zobrazeneho bonusu
                $("#playerBonusesModal .settings-content").hide();
                $("#playerBonusesModal #bonusesContentPromocode, #playerBonusesModal #bonusesContentActivatingBonus").hide();
                $("#playerBonusesModal .bonus-iframe").remove();
                $("#playerBonusesModal #bonusesList .bonus-menu-button").removeClass("non-ui-btn-active");
                switch (bonusType) {
                    case "activatingBonusManual":
                        // Aktivacny bonus
                        var activeBonus = [{
                                amount: 10,
                                spend: 1000,
                                applyAble: true
                            },
                            {
                                amount: 30,
                                spend: 3000,
                                applyAble: true
                            },
                            {
                                amount: 50,
                                spend: 5000,
                                applyAble: true
                            },
                            {
                                amount: 100,
                                spend: 10000,
                                applyAble: true
                            },
                            {
                                amount: 250,
                                spend: 20000,
                                applyAble: true
                            },
                            {
                                amount: 500,
                                spend: 50000,
                                applyAble: true
                            }
                        ];
                        $p("#playerBonusesModal #activatingBonusesTableWrapper").render(activeBonus, T.playerBonusesActivatingBonus);
                        $("#playerBonusesModal #activatingBonusesTableWrapper").trigger("create");
                        $("#playerBonusesModal .settings-content, #playerBonusesModal #bonusesContentActivatingBonus").show();
                        $("#playerBonusesModal #bonusesList").find("[bonus-id='bonus-" + bonusID + "']").addClass("non-ui-btn-active");
                    break;
                    case "PromoCode":
                        // Promokod a volne stavky
                        player.playerBonusModule.getFreebetList(bonusID, param, bonusName);
                    break;
                    default:
                    stored.bonusesStaticUrl = iFrameProgressUrl;
                    if (profile.Resolution === "1280x1024") {
                        stored.bonusesStaticUrl += "?zoom=" + sets.contentFactor1280x1024;
                    }
                    $("#bonusesContent").append('<iframe id="' + bonusName + 'Iframe" src="' + stored.bonusesStaticUrl + '" frameborder="0" scrolling="yes" class="bonus-iframe"></iframe>');
                    $("#" + bonusName + "Iframe").load(function() {
                        player.playerBonusModule.getBonusDetail(bonusID, bonusName);
                        $("#playerBonusesModal #bonusesList").find("[bonus-id='bonus-" + bonusID + "']").addClass("non-ui-btn-active");
                    });
                }
                stored.activeBonusName = bonusName;
            }
            return false;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia sluzi na ziskanie zoznamu hracskych freebetov
    getFreebetList: function(bonusID, param, bonusName) {
        try {
            var status = "";
            if (stored.PlayerID && (stored.PlayerID !== profile.ManualVerifiedPlayerID) && stored.Token) {
                // Len prihlaseny hrac (nesmie byt manualne overeny) s tokenom moze ziskat zoznam freebetov
                var requestUrl = url.centralSBAuth + "/players/" + stored.PlayerID + "/freebet-list/sk" + status;
                if (stored.BonusesFreebetsStatus !== 0) {
                    status = "?status=" + stored.BonusesFreebetsStatus;
                }
                $.ajax({
                    type: "GET",
                    url: requestUrl,
                    dataType: "json",
                    async: true,
                    beforeSend: function(xhr) {
                        xhr.setRequestHeader("Authorization", "Bearer " + stored.Token);
                    }
                })
                    .done(function(data) {
                        // Kontrola objektu
                        if (data === Object(data)) {
                            // Uspesne ziskanie zoznamu
                            $("#bonusesContent .settings-content, #bonusesContent #bonusesContentPromocode").show();
                            $("#playerBonusesModal #bonusesList").find("[bonus-id='bonus-" + bonusID + "']").addClass("non-ui-btn-active");
                            $p("#freebetsTableWrapper").render(data, T.playerBonusesFreebetList);
                            $("#freebetsTable").trigger("create");
                            // Select kategorii freebetov
                            $("#bonusesFreebetsList").find(".selected").removeClass("selected");
                            $("#bonusesFreebetsList #bonusFreebetItem" + stored.BonusesFreebetsStatus).addClass("selected");
                            $("#selectedFreebets").text(texts["BonusFreebetState" + stored.BonusesFreebetsStatus]);
                            // Informacne tlacitko k promokodom
                            if (bonusID) {
                                if (bonusName === "promocode") {
                                    $("#bonusesContent #promocodeInfoButton").hide();
                                } else {
                                    $("#bonusesContent #promocodeInfoButton").attr("onmousedown", "player.playerBonusModule.openBonusSubPage('" + param + "')").show();
                                }
                            }
                            player.playerSettingsModule.playerBonusesSelectToggle("Freebets", true);
                            shared.scrollModule.scrollButtons("bonuses-freebets");
                            return true;
                        } else {
                            // Neuspesne ziskanie zoznamu
                            main.createLog(2, "GetBonusesPlayerFreebets_Failed", "RequestURL: " + requestUrl);
                            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
                            return false;
                        }
                    })
                    .fail(function (jqXHR) {
                        jqXHR.requestUrl = requestUrl;
                        // Neuspesne ziskanie zoznamu
                        main.createLog(2, "GetBonusesPlayerFreebets_Failed", "# AJAX FAILED: " + JSON.stringify(jqXHR));
                        modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
                        return false;
                    });
                    return true;
            } else {
                main.createLog(2, "GetBonusesPlayerFreebets_Failed", "# PlayerID: " + stored.PlayerID + " # Token: " + !!stored.Token);
                modal.showErrObj(2, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            }
            return false;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            // Neuspesne ziskanie zoznamu
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            return false;
        }
    },

    // Funkcia otvara nativeApp klavesnicu na zadanie promokodu
    promoCodeManualInput: function() {
        try {
            $("#bonusesContentPromocode0 #promocodeInput").val("");
            PromoCodeManualInput();
            return true;
        } catch (e) {
            return false;
        }
    },

    // Funkcia sluzi na odoslanie promokodu na central sportbox sluzbu
    PromoCodeManualInsert: function(code) {
        try {
            if (!code && stored.browser) {
                code = $("#bonusesContentPromocode0 #promocodeInput").val();
            }
            if (code?.length < 6 || code?.length > 30) {
                main.createLog(2, "sendPromocode_Failed", "# PlayerID: " + stored.PlayerID + " # Token: " + !!stored.Token + " # code: " + code);
                modal.showErrObj(2, 5, {err1: texts.sendPromocode_Failed1, err2: texts.sendPromocode_Failed2, errType: "sendPromocode_Failed1"});
                return false;
            }
            if (stored.PlayerID && (stored.PlayerID !== profile.ManualVerifiedPlayerID) && stored.Token) {
                var requestUrl = url.centralSBAuth + "/players/promocode";
                $("#bonusesContentPromocode0 #promocodeInput").attr("value", code);
                var data = {
                    "playerId": stored.PlayerID,
                    "promocode": code,
                    "forPlatform": offer.platform
                }
                $.ajax({
                    type: "POST",
                    url: requestUrl,
                    contentType: "application/json; charset=utf-8",
                    accept: "*/*",
                    dataType: "json",
                    data: JSON.stringify(data),
                    timeout: 6000,
                    beforeSend: function(xhr) {
                        xhr.setRequestHeader("Authorization", "Bearer " + stored.Token);
                    },
                    success: function() {
                        if (data === Object(data)) {
                            modal.showErrObj(3, 5, {err1: texts.sendPromocode_Success1, err2: texts.sendPromocode_Success2, errType: "sendPromocode_Success1"});
                            player.playerBonusModule.getFreebetList();
                        } else {
                            // Neuspesne odoslanie
                            main.createLog(2, "sendPromocode_Failed", "RequestURL: " + requestUrl);
                            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
                            return false;
                        }
                    }
                    })
                    .fail(function (jqXHR) {
                        jqXHR.requestUrl = requestUrl;
                        // Neuspesne odoslanie alebo promokod uz bol zadany alebo ina chyba
                        main.createLog(2, "sendPromocode_Failed", "# AJAX FAILED: " + JSON.stringify(jqXHR) + " # DATA: " + JSON.stringify(data));
                        var err = {
                            err1: texts.sendPromocode_Failed1,
                            errType: "sendPromocode_Failed1"
                        };
                        try {
                            jqXHR.responseText = JSON.parse(jqXHR.responseText);
                            switch (jqXHR.responseText.ErrorCode) {
                                // Dodatocna informacia (2. riadok error hlasky) k neuspesnemu odoslaniu promokodu
                                case 111:
                                    // Promokód už bol zadaný alebo bol prečerpaný počet použití. (Pôvodne: Tento Promokód už bol použitý na Vašom hráčskom konte.)
                                    err.err2 = texts.sendPromocode_Failed3;
                                    break;
                                case 267:
                                    // Promokód je platný iba na Online.
                                    err.err2 = texts.sendPromocode_Failed4;
                                    break;
                                case 268:
                                    // Promokód je platný iba na Sportboxe. (K tomuto erroru by nemalo dochadzat, pretoze se jedna o zadanie promokodu pre platformu sportbox - offer.platform = "sportbox")
                                    err.err2 = texts.sendPromocode_Failed5;
                                    break;
                                default:
                                    // Nesprávne vyplnený promokód.
                                    err.err2 = texts.sendPromocode_Failed2;
                                    break;
                            }
                        } catch (e) {
                            err.err2 = texts.sendPromocode_Failed2;
                        } finally {
                            modal.showErrObj(2, 5, err);
                        }
                        return false;
                    });
            } else {
                main.createLog(2, "sendPromocode_Failed", "# PlayerID: " + stored.PlayerID + " # Token: " + !!stored.Token);
                modal.showErrObj(2, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            }
            return false;
        } catch (e) {
            // Neuspesne odoslanie
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            return false;
        }
    },

    // Funkcia sluzi na odoslanie poziadavky na aktivaciu aktivacneho bonusu
    activatingBonus: function(amount) {
        try {
            throw "Not implemented";
            if (amount) {
                var data = {
                    "playerId": stored.PlayerID,
                    "amount": amount
                  }
                var requestUrl = url.centralSB + "/bonus/activation-bonus/activation";
                $.ajax({
                    type: "POST",
                    url: requestUrl,
                    contentType:"application/json; charset=utf-8",
                    accept: "*/*",
                    dataType: "json",
                    data: JSON.stringify(data),
                    timeout: 6000,
                    success: function() {
                        if (data === Object(data)) {
                            modal.showErrObj(3, 5, {err1: texts.activationBonus_Success1, err2: texts.activationBonus_Success2, errType: "activationBonus_Success1"});
                            player.playerBonusModule.getFreebetList();
                        }
                      }
                  })
                .fail(function (jqXHR) {
                    jqXHR.requestUrl = requestUrl;
                    // Neuspesne odoslanie poziadavky
                    main.createLog(2, "activationBonus_Failed", "# AJAX FAILED: " + JSON.stringify(jqXHR));
                    modal.showErrObj(2, 5, {err1: texts.activationBonus_Failed1, err2: activationBonus_Failed2, errType: "activationBonus_Failed1"});
                    return false;
                });
            } else {
                main.createLog(2, "activationBonus_Failed", "# AMOUNT " + amount);
                modal.showErrObj(2, 5, {err1: texts.activationBonus_Failed1, err2: texts.activationBonus_Failed2, errType: "activationBonus_Failed1"});
            }
            return false;
        } catch (e) {
            // Neuspesne odoslanie poziadavky
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.createLog(2, "activationBonus_Failed1", "# ERROR");
            return false;
        }
    },

    // Zmena vo filtry freebetov v bonusoch
    modifyFreebetsBonusesFilter: function(propValue) {
        try {
            main.userAction();
            stored.BonusesFreebetsStatus = Number(propValue);
            player.playerBonusModule.getFreebetList();
            return true;
        } catch(e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Ziskanie stavu bonusov pre playera
    getBonusesStatus: function() {
        try {
            if (stored.PlayerID && (stored.PlayerID !== profile.ManualVerifiedPlayerID) && stored.Token) {
                var requestUrl = url.centralSBAuth + "/players/bonuses-status?forPlatform=" + offer.platform;
                $.ajax({
                    type: "GET",
                    url: requestUrl,
                    dataType: "json",
                    async: true,
                    beforeSend: function(xhr) {
                        xhr.setRequestHeader("Authorization", "Bearer " + stored.Token);
                    }
                })
                    .done(function(data) {
                        // Kontrola objektu
                        if (data === Object(data)) {
                            // Uspesne ziskanie stavu bonusov
                            if (data.hasActiveBonuses) {
                                $("#bonusesButton .bonus-button-dot").show();
                            } else {
                                $("#bonusesButton .bonus-button-dot").hide();
                            }
                            return true;
                        } else {
                            // Neuspesne ziskanie stavu bonusov
                            $("#bonusesButton .bonus-button-dot").hide();
                            main.createLog(2, "GetBonusesPlayerStatus_Failed", "# AJAX FAILED: not-object");
                            return false;
                        }
                    })
                    .fail(function (jqXHR) {
                        jqXHR.requestUrl = requestUrl;
                        // Neuspesne ziskanie stavu bonusov
                        $("#bonusesButton .bonus-button-dot").hide();
                        main.createLog(2, "GetBonusesPlayerStatus_Failed", "# AJAX FAILED: " + JSON.stringify(jqXHR));
                        return false;
                    });
            } else {
                main.createLog(2, "GetBonusesPlayerStatus_Failed", "# PlayerID: " + stored.PlayerID + " # Token: " + !!stored.Token);
                modal.showErrObj(2, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            // Neuspesne ziskanie stavu bonusov
            $("#bonusesButton .bonus-button-dot").hide();
            main.createLog(2, "GetBonusesPlayerStatus_Failed", "# ERROR");
            return false;
        }
    }
};
